import { shallowMount } from "@vue/test-utils";
import ModalComponent from "@/components/core/ModalComponent";

describe("ModalComponent component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ModalComponent);
  });

  it("Renders del component ModalComponent", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
